
import React, { memo } from 'react';

import cx from 'classnames';
import { Image, Text } from '../../../../../ui-kit';
import '../styles/_titled-form-block.scss';












function TitledFormBlock(
{
  itemImage,
  title,
  className,
  defaultImage,
  imagePlaceholder,
  children,
  hasSelectedItem,
  customContent
})
{
  return (
    <div className={cx('titled-form-block', className)}>
      {title ? <Text heading5 noMargin="top" className="titled-form-block__title">{title}</Text> : null}
      <div
        className={cx(
          'titled-form-block__content',
          { 'titled-form-block__content--selection-made': hasSelectedItem }
        )}>

        {
        customContent ?
        children :
        [
        <Image
          key="selectable-item-image"
          width="90px"
          height="90px"
          imageUrl={itemImage}
          defaultImageIcon={defaultImage}
          placeholderText={imagePlaceholder}
          rounded />,

        <div
          className="titled-form-block__content__children"
          key="selectable-item-children">

                {children}
              </div>]}


      </div>
    </div>);

}

export default memo(TitledFormBlock);